import { Theme, createStyles } from '@material-ui/core';
import { StyleRules } from '@material-ui/core/styles/withStyles';

const styles = (theme: Theme): StyleRules<string, {}> => createStyles({
  root: {
    width: 960,
    marginTop: theme.spacing(1),
    display: 'flex',
    justifyContent: 'space-between',
    [theme.breakpoints.down('sm')]: {
      width: '96%',
      alignSelf: 'center',
    },
  },
  printBox: {
    display: 'flex',
  },
  actionButton: {
    [theme.breakpoints.up('sm')]: {
      minWidth: 150,
    },
    height: 44,
  },
  buttonIcons: {
    [theme.breakpoints.up('sm')]: {
      marginRight: theme.spacing(1),
    },
  },
});

export default styles;
